<script setup lang="ts" generic="TData">
import type { Table } from '@tanstack/vue-table';

interface Props {
  table: Table<TData>;
  loading: boolean;
  isEmpty: boolean;
}

defineProps<Props>();
</script>

<template>
  <div
    v-if="!loading && !isEmpty"
    class="base-table__pagination"
  >
    <div class="base-table__pagination-info">
      Показано {{ table.getState().pagination.pageIndex * table.getState().pagination.pageSize + 1 }}
      -
      {{
        Math.min(
          (table.getState().pagination.pageIndex + 1) * table.getState().pagination.pageSize,
          table.getFilteredRowModel().rows.length,
        )
      }}
      из {{ table.getFilteredRowModel().rows.length }}
    </div>

    <div class="base-table__pagination-controls">
      <button
        :disabled="!table.getCanPreviousPage()"
        class="base-table__pagination-button"
        @click="table.previousPage()"
      >
        Назад
      </button>

      <span class="base-table__pagination-page">
        Страница {{ table.getState().pagination.pageIndex + 1 }} из
        {{ table.getPageCount() }}
      </span>

      <button
        :disabled="!table.getCanNextPage()"
        class="base-table__pagination-button"
        @click="table.nextPage()"
      >
        Вперед
      </button>

      <select
        :value="table.getState().pagination.pageSize"
        class="base-table__pagination-select"
        @change="(e) => table.setPageSize(Number((e.target as HTMLSelectElement).value))"
      >
        <option
          v-for="size in [10, 20, 30, 50, 100]"
          :key="size"
          :value="size"
        >
          Показать {{ size }}
        </option>
      </select>
    </div>
  </div>
</template>

<style scoped>
@reference "../../../../tailwind.css";

@layer components {
  .base-table__pagination {
    @apply flex items-center justify-between rounded-lg px-4 py-3;
    background-color: var(--surface-raised);
    color: var(--text-primary);
  }

  .base-table__pagination-info {
    @apply text-sm;
  }

  .base-table__pagination-controls {
    @apply flex items-center gap-3;
  }

  .base-table__pagination-button {
    @apply rounded-lg px-3 py-1.5 text-sm transition-colors disabled:cursor-not-allowed disabled:opacity-50;
    background-color: var(--button-primary-bg);
    color: var(--on-accent);
  }

  .base-table__pagination-button:not(:disabled):hover {
    background-color: var(--button-primary-hover);
  }

  .base-table__pagination-page {
    @apply text-sm;
  }

  .base-table__pagination-select {
    @apply rounded-lg border px-3 py-1.5 text-sm;
    background-color: var(--surface-sunken);
    border-color: var(--border);
    color: var(--text-primary);
  }
}
</style>
